import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/api'
});

if (typeof window !== 'undefined') {
  const t = localStorage.getItem('token');
  if (t) api.defaults.headers.common.Authorization = `Bearer ${t}`;
}

export const setToken = t => {
  api.defaults.headers.common.Authorization = t ? `Bearer ${t}` : '';
};

export default api;
